// extracted by mini-css-extract-plugin
module.exports = {"card-header":"OrdersList_card-header__1lbSx","card-content":"OrdersList_card-content__-uU91","orders":"OrdersList_orders__2tSqa"};